import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons/faXmarkCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TextField from "@mui/material/TextField"
import Autocomplete from "@mui/material/Autocomplete"
import { DomainDataError } from "app/api/types/DomainDataError"
import { IFilial } from "app/types/IFilial"
import { FiltroPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento"
import { Vendedor } from "app/types/Vendedor"
import clsx from "clsx"
import { on } from "events"
import { useFormik } from "formik"
import globalMU from "globalMU"
import React, { useEffect, useRef, useState } from "react"
import { InputData } from "../inputs/InputData"
import { set } from "date-fns"
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estiloTabela = require('../../estilos/tabelas.module.scss').default
const Situacoes = [
 {SitVen: 'A',Descricao: 'Apenas em orçamento'},
 {SitVen: '0',Descricao: 'Aguardando liberação'},
 {SitVen: '1',Descricao: 'Aguardando faturamento'},
 {SitVen: '2',Descricao: 'Faturado'},
 {SitVen: '3',Descricao: 'Cancelado'},
 {SitVen: '4',Descricao: 'Não Aprovado'},
 {SitVen: '5',Descricao: 'Pendente'},
 {SitVen: 'X',Descricao: 'Aguardando faturamento/Conferido'},
 {SitVen: 'Y',Descricao: 'Aguardando conferência'},
 {SitVen: 'I',Descricao: 'Aguardando confirmação'}
]
export interface DesdobramentoDadosFiltro {
    Filiais?: Partial<IFilial>[],
    Vendedores?: Vendedor[],
    DataInicial: string,
    DataFinal: string,
}
export interface DesdobramentoFiltro {
    Filial?: string,
    CodigoVendedor?: string,
    NomeCliente?: string,
    CodigoCliente?: number,
    DataInicial?: string,
    DataFinal?: string,
    Situacao?: string,
    NumeroPedido?: string,
}
export interface Desdobramento {
    NumeroPedido: number,
    BloqueiaDesdobramento: number,
    BloqueiaDesdobramentoAnterior: number,
    Filial: string,
    DtPedido: string,
    Cliente: string,
    ValorPedido: number,
    SitVen: string,
    Vendedor: string,
    Situacao: string,
    SitManut: string,
}

export interface ItemNumeroPedidoBloqueioDesdobramento {
    NumeroPedido: number,
    BloqueiaPedido: boolean
}
export interface DesdobramentoProps {
    dadosFiltro?: DesdobramentoDadosFiltro,
    filtro?: DesdobramentoFiltro,
    onPesquisarCliente: (filtro: Partial<FiltroPesquisaOrcamento>) => void,
    onPesquisar: (numeroPagina: number, filtro: DesdobramentoFiltro, clickBotaoPesquisar: boolean) => void,
    processandoPesquisa: boolean,
    onConfirmar: (listaNumeroPedido: ItemNumeroPedidoBloqueioDesdobramento[]) => Promise<boolean>,
    onMarcarTodos: (listaNumeroPedido: ItemNumeroPedidoBloqueioDesdobramento[]) => Promise<boolean | DomainDataError<boolean>>,
    onDesmarcarTodos: (listaNumeroPedido: ItemNumeroPedidoBloqueioDesdobramento[]) => Promise<boolean | DomainDataError<boolean>>,
    onLiberarManut: (listaNumeroPedido: ItemNumeroPedidoBloqueioDesdobramento[]) => void,
    onMarcaDesmarcaProps: (checked: boolean, value: number) => Promise<boolean | DomainDataError<boolean>>,
    listaDesdobramento: Desdobramento[],
    onAtualizaFiltrosNoPai: (filtros: DesdobramentoFiltro) => void,
    onChangeSenha: (senha: string) => void

}

export const Desdobramento = (props: DesdobramentoProps) => {
    const inputPesquisarRef = useRef(null);

    const formik = useFormik({
        initialValues: {
            ...props.filtro,
            NumeroPedido: props.filtro?.NumeroPedido ?? '',
            Situacao: props.filtro?.Situacao ?? '2',
            DataFinal: props.filtro?.DataFinal ?? new Date().toLocaleDateString('pt-BR'),
        },
        onSubmit: async (values) => {
            
            const erros = await formik.validateForm(values)

            if (Object.keys(erros).length > 0) {
                globalMU.showErrorMessage(erros)
                return false
            }
            if (globalMU.isNullOrEmpty(values.NumeroPedido)) {
                
                if (values.DataInicial == null || globalMU.isNullOrEmpty(values.DataInicial)) {
                    globalMU.showErrorMessage("Informe a Data Inicial!")
                    return false
                }

                if (values.DataFinal == null || globalMU.isNullOrEmpty(values.DataFinal)) {
                    globalMU.showErrorMessage("Informe a Data final!")
                    return false
                }

                if (values.DataInicial != null && values.DataFinal != null 
                        && new Date(globalMU.converterDataFormatoPTParaEN(values.DataInicial)) > new Date(globalMU.converterDataFormatoPTParaEN(values.DataFinal)) )
                {
                    globalMU.showErrorMessage("Data Final Menor que a Data Inicial!")
                    return false
                }                
            }
            //const produtosSelecionados = props.produtosFiltrados?.map((produto) => produto.Codigo)

            //var filtro = { ...values, ListaProdutosSelecionados: produtosSelecionados }
            var filtro = { ...values }
            await props.onLiberarManut(orcamentosSelecionados.map(o => ({
                NumeroPedido: o.NumeroPedido,
                BloqueiaPedido: props.listaDesdobramento.find((l) => l.NumeroPedido == o.NumeroPedido).BloqueiaDesdobramento == 1
            })))
            setOrcamentosSelecionados([])
            props.onPesquisar(1, filtro, true)
            setFormularioValidado(true);
        },
        validateOnBlur: true,
        validateOnChange: true,
        enableReinitialize: true,
        // validate: (values) => {
        //     const mensagemDataMenor = (campo1: string, campo2: string) => `O campo  "${campo1}" não pode ser maior do que a "${campo2}".`
        //     var ret = R.pickBy(value => globalMU.isNotNullOrEmpty(value), {
        //         DataInicial: new Date(values.DataInicial).getTime() > new Date(values.DataFinal).getTime() ? mensagemDataMenor("Data Inicial", "Data Final") : undefined,
        //     } as FormikErrors<ConsultaOrdemDeProducaoFiltro>)
        //     return FormikErrors<ConsultaOrdemDeProducaoFiltro>(ret)
        // }
    })
    
    const [formularioValidado, setFormularioValidado] = useState<boolean>(false)
    const [orcamentosSelecionados, setOrcamentosSelecionados] = useState<ItemNumeroPedidoBloqueioDesdobramento[]>([])

    const trataColunaBloqueio = (numeroPedido: number, bloqueiaDesdobramento: number) => {
        if ( orcamentosSelecionados.filter((o) => o.NumeroPedido === numeroPedido).length > 0) {
            return orcamentosSelecionados.find((o) => o.NumeroPedido === numeroPedido).BloqueiaPedido
        } else {
            return bloqueiaDesdobramento == 1
        }
    }

    const onMarcaDesmarca = async (e, value) => {
        const valorCheckBox = e.target.checked
        if (valorCheckBox && await props.onMarcaDesmarcaProps(valorCheckBox, value)) {
            if(orcamentosSelecionados.filter((o) => o.NumeroPedido === value).length > 0) {
                setOrcamentosSelecionados(orcamentosSelecionados.map((o) => {
                    if (o.NumeroPedido === value) {
                        return {NumeroPedido: value, BloqueiaPedido: true}
                    }
                    return o
                }))
            } else {
                setOrcamentosSelecionados([...orcamentosSelecionados, {NumeroPedido: value, BloqueiaPedido: true}])
            }
        } else if (!valorCheckBox && await props.onMarcaDesmarcaProps(valorCheckBox, value)) {
            if(orcamentosSelecionados.filter((o) => o.NumeroPedido === value).length > 0) {
                setOrcamentosSelecionados(orcamentosSelecionados.map((o) => {
                    if (o.NumeroPedido === value) {
                        return {NumeroPedido: value, BloqueiaPedido: false}
                    }
                    return o
                })
                )
            } else {
                setOrcamentosSelecionados([...orcamentosSelecionados, {NumeroPedido: value, BloqueiaPedido: false}])
            }
        }
    }

    useEffect(() => {
        props.onAtualizaFiltrosNoPai(formik.values)
    }, [formik.values])

    const filtroFiliais = <>
        <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
            <label
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
            >Filial
            </label>
            <select
                id="Desdobramento_ListaFiliais"
                name="Filial"
                value={(formik.values.Filial) ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
            >
                {props.dadosFiltro?.Filiais?.map((d) => (
                    <option
                        key={d.Codigo}
                        value={d.Codigo}
                    >
                        {d.Codigo + ' | ' + d.Nome}
                    </option>
                ))}
            </select>                
        </div>        
    </>

    const filtroVendedores = <>
        <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
            <label
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
            >Vendedor
            </label>
            <div className={`${estilosInputs.autocomplete} "_h-auto"`}>
                {props.dadosFiltro.Vendedores.length <= 1 ? (
                    <select
                        id="Desdobramento_ListaVendedores_Select"
                        className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
                        disabled={true}
                    >
                        {props.dadosFiltro.Vendedores.map((d) => (
                            <option key={d.Codigo} value={d.Codigo}>
                                {d.Nome}
                            </option>
                        ))}
                    </select>
                ) : (
                    <Autocomplete
                        style={{ minWidth: '400px' }}
                        noOptionsText="Digite..."
                        id="Desdobramento_ListaVendedores"
                        className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
                        options={props.dadosFiltro.Vendedores}
                        getOptionLabel={(option) => option.Codigo + " - " + option.Nome}
                        isOptionEqualToValue={(option, value) => option.Codigo === value.Codigo}
                        disabled={props.processandoPesquisa}
                        onChange={(event, value) => {
                            if (value && typeof value === 'object' && 'Codigo' in value) {
                                formik.setFieldValue("CodigoVendedor", value.Codigo);
                            } else {
                                formik.setFieldValue("CodigoVendedor", null);
                            }
                        }}
                        value={props.dadosFiltro.Vendedores.find(v => v.Codigo === formik.values.CodigoVendedor) || null}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                size="small"
                                placeholder="Digite..."
                                title="Digite o nome ou código do Vendedor"
                            />
                        )}
                        disablePortal={true}
                    />
                )}
            </div>
        </div>
    </>

    const filtroCliente = <>
        <div className="_flex _my-2">
            <label className="_text-right _w-[160px] _font-normal _mb-0 _mr-3">Cliente</label>
            <div className="_flex _items-center">
                <input className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                    id="Desdobramento_CampoFiltro_nomeCliente"
                    type="text" name="NomeCliente" value={(formik.values.NomeCliente) ?? ""} 
                    readOnly
                    disabled // sempre fica desabilitad
                    title="Clique na lupa para pesquisar o cliente"
                    placeholder="Clique na lupa para pesquisar"
                />
                <input type="hidden" name="CodigoCliente" value={formik.values.CodigoCliente} />
                <div className="flex _gap-x-3">
                    <FontAwesomeIcon icon={faSearch} color="#3c8ac9" className="_text-2xl _mx-2" cursor={"pointer"}
                        onClick={() => props.onPesquisarCliente(formik.values)} />
                    <FontAwesomeIcon icon={faXmarkCircle} color="#f25713" className="_text-2xl" cursor={"pointer"}
                        onClick={() => {
                            formik.setFieldValue("NomeCliente", "")
                            formik.setFieldValue("CodigoCliente", "")
                        }} />
                </div>
            </div>
        </div>        
    </>

    const filtroDataPedido = <>
        <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
            <label
                className={clsx(estilosInputs.labelObrigatorio, "_text-right _w-[160px] _font-normal _mb-0 _mr-3")}
            >Data Pedido
            </label>
            <div className="_flex _items-center ">
                <InputData
                    id="Desdobramento_DataInicial_Input"
                    data={formik.values.DataInicial}
                    onChange={(data) => (formik.setFieldValue("DataInicial", globalMU.converterDataFormatoENParaPT(data)))}
                    className="_w-[120px] _mr-2"
                />
                <span className="_text-center _w-[64px]">até</span>
                <InputData
                    id="Desdobramento_DataFinal_Input"
                    data={formik.values.DataFinal}
                    onChange={(data) => (formik.setFieldValue("DataFinal", globalMU.converterDataFormatoENParaPT(data)))}
                    className="_w-[120px]"
                />
            </div>
        </div>
    </>

    const filtroSituacao = <>
        <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
            <label
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
            >Situação
            </label>
            <select
                id="Desdobramento_ListaSituacoes"
                name="Situacao"
                value={(formik.values.Situacao) ?? ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled
                className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
            >
                {Situacoes.map((d) => (
                    <option
                        key={d.SitVen}
                        value={d.SitVen}
                    >
                        {d.Descricao}
                    </option>
                ))}
            </select>                
        </div>        
    </>

    const filtroNumeroPedido = <>
        <div className={`${estilosInputs.gridAutocomplete} "_flex _my-2"`}>
            <label
                className="_text-right _w-[160px] _font-normal _mb-0 _mr-3"
            >Nº Pedido
            </label>
            <input
                id="Desdobramento_NumeroPedido"
                name="NumeroPedido"
                maxLength={9}
                value={(formik.values.NumeroPedido) ?? ""}
                onChange={(e) => { globalMU.validateNumberInteger(e.target.value) && formik.handleChange(e)} }
                onBlur={formik.handleBlur}
                className={clsx("_w-[300px]", estilosInputs.inputPadrao)}
            />
        </div>
    </>

    const BotoesPesquisa = <>
        <div>
            <button
                className={clsx(estilosBotoes.botaoPrimario)}
                type="submit"
                id="Desdobramento_botaoPesquisar"
                ref={inputPesquisarRef}
                disabled={props.processandoPesquisa}
            >
                Pesquisar
            </button>
        </div>
    </>

    const BotaoMarcarTodos = <>
    <div>
        <button
            className={clsx(estilosBotoes.botaoPrimario)}
            type="button"
            id="Desdobramento_botaoMarcartodos"
            disabled={props.listaDesdobramento.length ==0}
            onClick={async (e) => {
                e.preventDefault()
                var lista = props.listaDesdobramento
                .filter(l => 
                    (l.BloqueiaDesdobramento != 1 && !orcamentosSelecionados.find(o => o.NumeroPedido == l.NumeroPedido)) ||
                    orcamentosSelecionados.find(o => o.NumeroPedido == l.NumeroPedido)?.BloqueiaPedido == false
                )
                .map(l => ({ NumeroPedido: l.NumeroPedido, BloqueiaPedido: true }));

                var result = await props.onMarcarTodos(lista)

                if (result) {
                    setOrcamentosSelecionados(lista.concat(orcamentosSelecionados.filter(o => o.BloqueiaPedido == true)).map((l) => ({
                        NumeroPedido: l.NumeroPedido, 
                        BloqueiaPedido: true})
                    ))
                }
            }}
        >
            Marcar Todos
        </button>
    </div>
    </>

    const BotaoDesmarcarTodos = <>
        <div>
            <button
                className={clsx(estilosBotoes.botaoPrimario)}
                type="submit"
                id="Desdobramento_botaoDesmarcarTodos"
                disabled={props.listaDesdobramento.length ==0}
                onClick={async (e) => {
                    e.preventDefault()
                    
                    var lista = props.listaDesdobramento
                    .filter(l => 
                        (l.BloqueiaDesdobramento == 1 && !orcamentosSelecionados.find(o => o.NumeroPedido == l.NumeroPedido)) ||
                        orcamentosSelecionados.find(o => o.NumeroPedido == l.NumeroPedido)?.BloqueiaPedido == true
                    )
                    .map(l => ({ NumeroPedido: l.NumeroPedido, BloqueiaPedido: false }));

                    var result = await props.onMarcarTodos(lista)
                    
                    if (result) {
                        setOrcamentosSelecionados(lista.concat(orcamentosSelecionados.filter(o => o.BloqueiaPedido == false)).map((l) => ({
                            NumeroPedido: l.NumeroPedido, 
                            BloqueiaPedido: false})
                        ))
                    }
                }}
            >
                Desmarcar Todos
            </button>
        </div>
    </>

    const senhaLiberacao = (parteKey: string) => {
        return ( <>
        <div className="_bg-gray-200 _p-2 _my-2 _rounded-md">
            <label className={estilosInputs.labelObrigatorio}>Senha (Alterado permissão de desdobramento)</label>
            <div>
                <input
                    className="_mr-2"
                    autoComplete="off"
                    aria-autocomplete="none"
                    type="password"
                    id={`Desdobramento_CampoSenha_${parteKey}`}
                    name={`SenhaLiberacao_${parteKey}`}
                    //autoFocus
                    onChange={(e) => props.onChangeSenha(e.target.value)}
                />            
                <button
                    className={clsx(estilosBotoes.botaoPrimario)}
                    onClick={async () => {
                        
                        const listaItemNumeroPedidoDesdobramento = orcamentosSelecionados
                        .filter((s) => props.listaDesdobramento.find((l) => l.NumeroPedido == s.NumeroPedido)?.BloqueiaDesdobramento != Number(s.BloqueiaPedido))
                        .map(m => ({ NumeroPedido: m.NumeroPedido, BloqueiaPedido: m.BloqueiaPedido }))

                        if(orcamentosSelecionados.length != 0 && listaItemNumeroPedidoDesdobramento.length == 0) {
                            globalMU.showErrorMessage("Nenhuma alteração será feita, nada foi alterado.")
                            return
                        }
                        var result = await props.onConfirmar(listaItemNumeroPedidoDesdobramento)
                        if(result) {
                            setOrcamentosSelecionados([])
                            props.onPesquisar(1, formik.values, true)
                        }
                    }}
                    id={`botaoConfirmar_${parteKey}`}
                    key={`botaoConfirmar_${parteKey}`}
                >
                    Confirmar
                </button>
            </div>
        </div>
    </>
    )
   }

    const headerTabela = () => {
        const mapHeader = ["Bloq","Filial","Data", "Orçamento","Cliente","Valor","Situação", "Vendedor"];

        return mapHeader.map((nome) =>

            <th
                key={nome}
                className="_table-cell"
                id={`Tabela_Body_caceçalho_Cell_${nome}`}
                style={{ position: 'relative', textAlign: 'center', paddingRight: '30px' }}
            >
                {nome}
            </th>
        )
    }

    const bodyTabela = (dado: Desdobramento) => {
        const mapHeader =
        {
            'Bloq': dado.BloqueiaDesdobramento,
            'Filia': dado.Filial,
            'Data': globalMU.formatDate(dado.DtPedido),
            'Orçamento': dado.NumeroPedido,
            'Cliente': dado.Cliente,
            'Valor': globalMU.formatMoney( dado.ValorPedido),
            'Situação': dado.Situacao,
            'Vendedor': dado.Vendedor,
        }
        return Object.keys(mapHeader).map((campo, index) =>
            <td
                style={campo == 'Bloq'  || campo == 'Filia'  || campo == 'Filial'
                        ? { textAlign: 'center'}
                        : campo == 'Valor' 
                            ? { textAlign: 'right' }
                            : { textAlign: 'left' }
                }
                id={`Tabela_Body_Row_Cell_${index}_${campo}`}
                key={`${index}_${campo}`}
                className={`_table-cell`}
            >
                {campo == 'Bloq'
                    ? <input
                        type="checkbox"
                        style={{ textAlign: 'center' }}
                        checked={trataColunaBloqueio(dado.NumeroPedido, dado.BloqueiaDesdobramento) || false}
                        onClick={(e) => onMarcaDesmarca(e, dado.NumeroPedido)}
                        id={`Tabela_Body_Row_Cell_input_${index}`}
                        key={`input_${index}`}
                    /> 
                    : mapHeader[campo]}
            </td>
        )
    }

    return (
        <>
            <form
                id="Desdobramento_FormularioFiltroPesquisa"
                onSubmit={(e) => {
                    e.preventDefault();
                    if (inputPesquisarRef.current) {
                        inputPesquisarRef.current.focus(); // Set focus to the input field
                    }
                    formik.handleSubmit();
                }}
            >
                {filtroFiliais}
                {filtroVendedores}
                {filtroCliente}
                {filtroDataPedido}
                {filtroSituacao}
                {filtroNumeroPedido}

                <div className="_flex _gap-2">
                    {BotoesPesquisa}
                    {props.listaDesdobramento?.length > 0 &&
                    <>
                    {BotaoMarcarTodos}
                    {BotaoDesmarcarTodos}
                    </>}
                </div>
            </form>
            <br />
            
            {props.listaDesdobramento?.length > 0 && <>
            
            {senhaLiberacao('inicio')}
            
            <div className={estiloTabela.containerRolavel}>
                <table className={`_table _w-full  ${estiloTabela.tabela}`}
                    id="Desdobramento_Tabela"
                >
                    <thead className="_table-header-group"
                        id="Desdobramento_Tabela_Header"
                    >
                        <tr className="_table-row"
                            id="Desdobramento_Tabela_Header_Row"
                        >
                            {headerTabela()}
                        </tr>
                    </thead>
                    <tbody className="_table-row-group"
                        id="Desdobramento_Tabela_Body"
                    >
                        {props.listaDesdobramento?.map((dado) => (
                            <tr className={`_table-row`}
                                id={`Desdobramento_Tabela_Body_Row+${dado.NumeroPedido}`}
                                key={dado.NumeroPedido}
                            >
                                {bodyTabela(dado)}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            
            {props.listaDesdobramento?.length > 3 && <>
            {senhaLiberacao('FINAL')}
            </>}
             </>}
            <section style={{ marginBottom: "100px" }} />
        </>
    )
}